export const PRICE_TEMPLATE = '{{amount_with_comma_separator}}';
